<template lang="pug">
.auth
  .auth_form
    template(v-if="isMobile")
      .referrer(v-if="isReferrerUrl")
        span.referrer__text {{ $t('label.transition.source') }}
        a.referrer__logo(href="https://www.emanat.az/az"  target="_blank")
          img(alt="emanat" src="@/assets/e-manat.svg")
      h2.auth_form_title {{ $t('misc.auth.sign_in.title') }}
    h2(v-else).auth_form_title {{ $t('misc.auth.login.number')}}
    v-form(ref="login" v-model="loginForm" :disabled="loading"
    @submit.native.prevent="login")
      v-text-field(
        prefix="+994"
        @maska="checkUsername"
        outlined
        type="phone"
        :rules="rules.username"
        v-maska:[options]="auth.username"
        :label="$t('label.phone_number')"
        required
        :validate-on-blur="true"
        ref="username"
        @input="message = ''; responseError=[]"
        :error="message.length > 0")
      .password
        v-text-field(
          :append-icon="show1 ? '$show-password' : '$hide-password'"
          outlined
          v-model="auth.password"
          :rules="rules.password"
          :label="$t('label.password')"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
          ref="password"
          @input="message = ''; responseError=[]"
          :error-messages="responseError"
          :error="message.length > 0"
          required)
        router-link.text-decoration-none(:to="{ name: 'forgot' }")
          | {{ $t('action.forgot_password') }}
      v-btn(id="sign_in" depressed block x-large color="primary" type="submit"
        :loading="loading" :disabled="!loginForm || !canContinue") {{ $t('action.sign_in') }}
      .auth_mobile
        p {{ $t('misc.auth.without_account') }}
        span(@click="redirectRegister") {{ $t('misc.auth.sign.app')}}
  AppFrame(
    :frameTitle="authLoginFrameTitle"
    :frameContents="authLoginFrameContents"
    :hasDynamicQr="true"
  )
  AppAuthModal(:isAuthModalVisibility="isAuthModalVisibility" frameTitle="misc.auth.account.complete.registration" :frameContents="registerFrameContents" @closeAuthModal="redirectRegister")
</template>
<script>
import { ValidationRequired } from '@/rules/required';
import { ValidationPattern } from '@/rules/pattern';
import { detectAutofill } from '@/helpers/detectAutofill';
import { LoginRequests } from '@/services/http/login-requests';
import { UserService } from '@/services/user-service';
import { authLoginFrameTitle, authLoginFrameContents } from '@/constants/auth';
import AppFrame from '@/views/auth/components/AppFrame';
import AppAuthModal from '@/views/auth/components/AppAuthModal';
import { convertBase64 } from '@/helpers/base64Encoder';
import { mapGetters } from 'vuex';

export default {
  name: 'LoginPage',
  components: {
    AppFrame,
    AppAuthModal,
  },
  data() {
    return {
      value: 'https://sbplus.mpay.az/mpay-link',
      size: 202,
      isAuthModalVisibility: false,
      loginForm: true,
      show1: false,
      message: '',
      loading: false,
      canContinue: false,
      authLoginFrameTitle,
      authLoginFrameContents,
      registerFrameContents: [
        'misc.auth.open.camera',
        'misc.auth.scan.qr',
        'misc.auth.download.app',
      ],
      get isReferrerUrl() {
        return !!sessionStorage.getItem('referrerUrl');
      },
      auth: {
        username: {
          masked: '',
          unmasked: '',
          completed: false,
        },
        password: '',
      },
      options: {
        eager: true,
        mask: '## ### ## ##',
      },
      responseError: [],
      rules: {
        username: [ValidationRequired(), ValidationPattern('(?:\\s*\\d){9}', 'validation.login.number')],
        password: [ValidationRequired()],
      },
    };
  },
  computed: {
    ...mapGetters('websocket', {
      customQrCode: 'getMessage',
      isClosed: 'getIsClosed',
    }),
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.checkAutofill();
    });
  },
  methods: {
    convertBase64,
    checkUsername(e) {
      this.canContinue = e.detail.completed;
    },
    async checkAutofill() {
      const usernameFilled = await detectAutofill(this.$refs.username.$refs.input);
      const passwordFilled = await detectAutofill(this.$refs.password.$refs.input);

      if (usernameFilled && passwordFilled) {
        this.canContinue = true;
        this.loginForm = true;
      }
    },
    async login() {
      if (!this.$refs.login.validate()) {
        return;
      }

      this.loading = true;

      const [response, error] = await LoginRequests.login({
        username: `+994${this.auth.username.unmasked}`,
        password: this.auth.password,
      });
      this.loading = false;

      if (error) {
        this.responseError.push(error.errorDetails[0].message);
        this.message = error.errorDetails[0].message;
        // this.$notify.error(error.errorDetails[0].message);
      } else {
        UserService.login(response.data.token);
        this.$router.replace({ name: 'dashboard-root' });
      }
    },
    redirectRegister() {
      if (this.$vuetify.breakpoint.width < 800) {
        const overlay = document.getElementById('inspire');
        if (!this.isAuthModalVisibility) {
          overlay.classList.add('isAuthModalVisibility');
          this.isAuthModalVisibility = true;
        } else {
          overlay.classList.remove('isAuthModalVisibility');
          this.isAuthModalVisibility = false;
        }
      } else {
        this.$router.push('/auth/register');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/auth.scss';
</style>
